import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const FormType = ({type,setType}) => {
  const handleChange = (event) => {
    setType(event.target.value);
  };
  return <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
  <InputLabel 
  id="demo-simple-select-standard-label"
  className='capitalize'
  >{type? type : "Type"}</InputLabel>
  <Select
    labelId="demo-simple-select-standard-label"
    id="demo-simple-select-standard"
    value={type}
    onChange={e => setType(e.target.value)}
    
  >
    <MenuItem value="restaurants">Restaurants</MenuItem>
    <MenuItem value="hotels">Hotels</MenuItem>
    <MenuItem value="attractions">Attractions</MenuItem>
  </Select>
</FormControl>;
};

export default FormType;
